import React, { memo, useCallback, useState } from "react";
import { Image } from "react-bootstrap";
import FullScreenImageModal from "./FullScreenImageModal";

type Props = {
  imgPath: string;
  toggleAutoPlay: boolean;
};

const AUTOPLAY_DURATION = 5000;

const CarouselSlide: React.FC<Props> = ({ imgPath, toggleAutoPlay }) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [showFullScreen, setShowFullscreen] = useState(false);
  const setLoaded = useCallback(() => {
    setHasLoaded(true);
  }, []);
  return (
    <div
      className={`embla__slide ${hasLoaded ? "has-loaded" : ""}`}
      key={imgPath}
    >
      <div
        key={imgPath}
        className={`rl-cloud_sandbox__screenshots-progress-bar`}
        style={{
          animationName: toggleAutoPlay ? "progressAnimation" : "none",
          animationDuration: `${AUTOPLAY_DURATION}ms`
        }}
      />

      <Image
        onClick={() => {
          setShowFullscreen(true);
        }}
        className="embla__slide__img"
        fluid
        src={imgPath}
        onLoad={setLoaded}
        alt=""
      />

      <FullScreenImageModal
        show={showFullScreen}
        imgPath={imgPath}
        onHide={() => setShowFullscreen(false)}
      />
    </div>
  );
};

export default memo(CarouselSlide);
